define([], function(){
    var en = {
        detail: {name: 'Case Presentation Images'},
        topBarLinks: [
            {name: 'Visit Shanghai Living Room', class: 'sh-appoint'},

            // {name: 'How to Shop', link: '/shop'},
            // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
            {name: 'Contact Us', link: '/site/cooperate'}
        ],
        headLeft: {
            brand: 'Brand',
            crest: 'CrestLine',
            earth: 'EarthLine',
            ff: 'FnjiFore',
            register: 'Register',
            login: 'Login',
            logout: 'Logout',
            cart: 'Cart',
            order: 'Order'
        },
        // navMenu: [
        //     {name: 'FNJI', link: '/', menu: []},
        //     {name: 'FURNITURE', link: '/furniture?tab=all',category: '1',menu:
        //             [{name: 'All',link: '/furniture?tab=all'},
        //                 {name: 'Chair',link: '/furniture?tab=all#chair'},
        //                 {name: 'Table',link: '/furniture?tab=all#desk'},
        //                 {name: 'Bed',link: '/furniture?tab=all#bed'},
        //                 {name: 'Teapoy',link: '/furniture?tab=all#lowtable'},
        //                 {name: 'Cabinet',link: '/furniture?tab=all#cab'},
        //                 {name: 'Sofa',link: '/furniture?tab=all#sofa'},
        //                 {name: 'Fnji Plank',link: '/furniture?tab=all#ymb'},
        //                 {name: 'Others',link: '/furniture?tab=all#other'},
        //             ]},
        //     {name: 'HOME', link: '/grocery?tab=all',category: '2', menu:
        //             [{name: 'All',link: '/grocery?tab=all'},
        //                 {name: 'Lighting',link: '/grocery-l2?bom=C01-11'},
        //                 {name: 'Textiles',link: '/grocery-l2?bom=C01-12'},
        //                 {name: 'Dinning&Kitchen',link: '/grocery-l2?bom=C01-13'},
        //                 {name: 'Storage',link: '/grocery-l2?bom=C01-14'},
        //                 {name: 'Fragrance',link: '/grocery-l2?bom=C01-15'},
        //                 {name: 'Accessories',link: '/grocery-l2?bom=C01-16'},
        //                 {name: 'Electronics',link: '/grocery-l2?bom=C01-17'},
        //                 {name: 'Outdoor',link: '/grocery-l2?bom=C01-18'},
        //                 {name: 'Lifestyle',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: 'GALLERY', link: '/gallery', menu:
        //             [
        //                 // {name:"Exhibit", link:"/gallery#artist"},
        //                 // {name:"Stage", link:"/gallery#works"},
        //                 // {name:"POP-UP Store", link:"/gallery#exhibit"}
        //             ]},
        //     {name: 'COLUMN', link: '/home',menu: [
        //             {name:"FNJI at Home", link:"/home-athome"},
        //             {name:"FNJI visit Friend", link:"/home-drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     {name: 'ABOUT FNJI', link: '/fnjinews', menu: []},
        //     {name: 'PURCHASE', link: '/buyChannel', menu: []}
        // ],
        navMenu: [
            {name: 'Home', link: '/', children: []},
            {name: 'Furniture', link: '/furniture?tab=C09',category: '1', children: []},
            {name: 'Furnishings', link: '/grocery?tab=G01',category: '2', children: []},
            {name: 'Projects', link: '/caseNew', children: [
                    {name: 'Fnji At Home',link: '/athome',type: 1},
                    {name: 'Commercial Project',link: '/project',type: 2}
                ]},
            {name: 'ShowRooms', link: '/shops', children: [
                    {name: 'Beijing Sanlitun Taikooli Store',phoneTitle: 'Beijing',phoneName: 'Sanlitun Taikooli Store',link: '/exhibitionhall?id=2',type: 1},
                    {name: 'Beijing Indigo Store',phoneTitle: '',phoneName: 'Indigo Store',link: '/exhibitionhall?id=3',type: 1},
                    {name: 'Beijing Guozijian Living Room',phoneTitle: '',phoneName: 'Guozijian Living Room',link: '/exhibitionhall?id=4',type: 1},
                    {name: 'Shanghai Qiantan Taikoo Li store',phoneTitle: 'Shanghai',phoneName: 'Qiantan Taikoo Li store',link: '/exhibitionhall?id=5',type: 2},
                    {name: 'Shanghai Wukang Rd Living Room',phoneTitle: '',phoneName: 'Wukang Rd Living Room',link: '/exhibitionhall?id=6',type: 2},
                    {name: 'Guangzhou TEEM SENSES Store',phoneTitle: 'Guangzhou',phoneName: 'Yuehai Tiandi Store',link: '/exhibitionhall?id=7',type: 3},
                    {name: 'Shenzhen Wanxiang Qianhai Store ',phoneTitle: 'Shenzhen',phoneName: 'Wanxiang Qianhai Store',link: '/exhibitionhall?id=8',type: 4},
                    {name: 'Shenzhen Zhuoyue Center store',phoneTitle: '',phoneName: 'Zhuoyue Center store',link: '/exhibitionhall?id=9',type: 4},
                    // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                    {name: 'Hangzhou Liuhe Road Store',phoneTitle: 'Hangzhou',phoneName: 'Liuhe Road Store',link: '/exhibitionhall?id=11',type: 6},
                    {name: 'Suzhou Eslite Store',phoneTitle: 'Suzhou',phoneName: 'Eslite Store',link: '/exhibitionhall?id=12',type: 7},
                    // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                    {name: 'Nanjing Jinying Store',phoneTitle: 'Nanjing',phoneName: 'Jinying Store',link: '/exhibitionhall?id=14',type: 8},
                    {name: 'Chengdu Fusen Store',phoneTitle: 'Chengdu',phoneName: 'Fusen Store',link: '/exhibitionhall?id=15',type: 5},
                    {name: 'Xian Wanxiang Store',phoneTitle: 'Xian',phoneName: 'Wanxiang Store',link: '/exhibitionhall?id=16',type: 9}
                ]},
            {name: 'Arts/Column', link: '/gallery', children: [
                    {name: 'Exhibition·Stage·Pop-Up·',link: '/gallery',type: 1,phoneChildren: [
                            {name: 'Exhibition',link: '/gallery'},
                            {name: 'Stage',link: '/gallery'},
                            {name: 'Pop-Up',link: '/gallery'}
                        ]},
                    {name: 'VISITING FRIENDS',link: '/home-drop',type: 2}
                ]},
            // {name: '栏目', link: '/home'},
            {name: 'About', link: '/fnjinews', children: []},
            {name: 'Downloads', link: '/download', children: [
                    {name: 'Product Models',link: '/download',type: 1},
                    {name: 'Catalog',link: '/catalog',type: 2},
                ]},
            {name: 'Purchase', link: '/buyChannel', children: []}
        ],
        footerNew: [
            {name: 'PRESS', link: '/fnjimedia'},
            {name: 'HIRING', link: '/job'},
            {name: 'SERVICE', link: '/aboutservice'},
            {name: 'CONTACT', link: '/site/cooperate?type=1'}
        ],
        menuGroups: [
            {
                title: 'ABOUT US',
                list: [
                    {name: 'About Fnji', link: '/fnjinews'},
                    {name: 'How to Buy', link: '/buyChannel'},
                    {name: 'Press', link: '/fnjimedia'},
                    {name: 'Join Us', link: '/job'}
                ]
            },
            {
                title: 'SHOPPING GUIDANCE',
                list: [
                    {name: 'Placing an Order', link: '/howshop'},
                    {name: 'Membership', link: '/membership'}
                ]
            },
            {
                title: 'ABOUT DELIVERY',
                list: [
                    {name: 'Furniture Delivery', link: '/aboutdeliver?index=0'},
                    {name: 'Grocery Delivery', link: '/aboutdeliver?index=1'},
                    {name: 'Fnji Plank Delivery', link: '/aboutdeliver?index=2'}
                ]
            },
            {
                title: 'CUSTOMERSERVICE',
                list: [
                    {name: 'Furniture Service', link: '/aboutservice?index=0'},
                    {name: 'Grocery Delivery', link: '/aboutservice?index=1'}
                ]
            },
            {
                title: 'CONTACT US',
                list: [
                    {name: 'Bulk Purchase', link: '/site/cooperate?type=1'},
                    {name: 'Design Studio Collaboration', link: '/site/cooperate?type=2'},
                    {name: 'Home Furnishing Brand Cooperation', link: '/site/cooperate?type=3'},
                    {name: 'Marketing & Media Cooperation', link: '/site/cooperate?type=4'},
                    {name: 'Artwork Collaboration', link: '/site/cooperate?type=5'},
                    {name: 'Download Catalogs', link: '/temp/upload/productinfo/产品目录.zip'}
                ]
            }
        ],
        fnjiIndexNew: {
            aboutFnji: 'ABOUT FNJI',
            // aboutFnjiCon: 'Rooted in the profound oriental aesthetics, the design condenses the expression and inheritance, and',
            // aboutFnjiCon2: 'integrates the understanding and thinking of nature.It is Fnji\'s value and mission to be loyal to the self by',
            // aboutFnjiCon3: 'conveying its distinctive style, aesthetics and lifestyle delicately and effectively.',
            // aboutFnjiCon4: 'It is also an interpretation of the concept of “Nature bred, Home nourished”.',
            aboutFnjiCon: 'FNJI was founded in 2010 and is a lifestyle aesthetics brand that integrates furniture and home furnishings.',
            aboutFnjiCon2: '"Fan" means clean and quiet, and "Ji" means furniture, which means clean and quiet furniture. At the same time,',
            aboutFnjiCon3: 'the homonym of Fanji is "FANJI", which means ordinary furniture. "Oriental modern, natural and meaningful" is ',
            aboutFnjiCon4: 'the keyword of the brand, which is the concept and persistence of Fanji rooted in the soil of the East and ',
            aboutFnjiCon5: 'constantly exploring aesthetic life. "NATURE BRED HOME NOURISHED" takes natural materials and simulates the ',
            aboutFnjiCon6: 'state of nature. FNJI insists on using wood as the main body, integrating leather, wool, stone and other natural ',
            aboutFnjiCon7: 'materials, and returning the aura taken from the mountains to daily life.',
            aboutFnjiBt: 'More about FNJI',
            furnitureTitle: 'Furniture',
            furniture: 'The concept of "Nature bred, Home nourished" of Fnji furniture integrates a variety of',
            furniture2: 'design languages such as deep solemnity, simplicity, modern diversity and so on.',
            furniture3: 'Explore aesthetic balance and inspiration between East and West, between modernity',
            furniture4: 'and tradition, and between memory and future.',
            earth: 'EARTH LINE',
            earthInfo: 'Wise and pure as boundless earth.',
            crest: 'CREST LINE',
            crestInfo: 'Solemn as the misty shadow above the mountain crest.',
            fnjiFore: 'FNJI FORE',
            fnjiForeInfo: 'Explore the possibilities of future life in China.',
            moreFur: 'More Furniture',
            fnjiathome: 'Fnji At Home',
            fnjiathomeCon: 'In order to deeply explore the lifestyle attitude of furniture owners and observe the relationship ',
            fnjiathomeCon2: 'between furniture and people Intimate connections between people, Fnji self-made program ',
            fnjiathomeCon3: '"Fnji at Home" Starting from different dimensions, tell the story of furniture, design, and people',
            cooperation: 'Commercial Project',
            cooperationCon: 'FNJI and commercial space produce linkage, in different styles together interpret the tolerance and ',
            cooperationCon2: 'infinite possibilities of FNJI furniture. FNJI has been exploring the resonance of design and nature',
            cooperationCon3: 'between different places and objects. ',
            furnishings: 'HOME FURNlSHlNGS',
            homeCon: 'Life Store selects quality household goods from around the world with high',
            homeCon2: 'standards. Quality household goods make people feel happy and bring to life',
            homeCon3: 'a sense of ceremony. More importantly, they present the life aesthetic system',
            homeCon4: 'recognized and admired by Fnji.',
            moreHome: 'More Homeware',
            artTitle: 'Arts/Column',
            artCon: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-up Store. Fnji breaks the',
            artCon2: 'boundaries of traditional art and taps into the infinite possibilities of art. It allows',
            artCon3: 'the audience to perceive the art presented in different carriers and leads them into the',
            artCon4: 'art world of infinite imagination.',
            moreInfo: 'More Information',
            journalCon: 'In order to explore the living attitudes of furniture owners and observe the intimate',
            journalCon2: 'connections between furniture and people and among people, Fnji makes columns "FNJI at',
            journalCon3: 'Home" and "FNJI Visit Friend" to tell the stories of furniture, design and people from',
            journalCon4: 'different dimensions.',
            projectCon: 'Fnji cooperate with commercial spaces, designers and owner-principals to interpret',
            projectCon2: 'the comprehensive and infinite possibility of Fnji furniture in different styles.',
            morePro: 'More Project',
            howtobuy: 'Purchase',
            lineStore: 'ONLINE STORE',
            lineStores: '| TMALL | JD | Wechat mini program｜',
            phyStore: 'SHOWROOMS',
            phyStores: ['Beijing','Shanghai','Guangzhou','Shenzhen','Chengdu','Hangzhou','Suzhou','Nanjing'],
            aboutAllBt: 'More Purchase',
            footerInfo: 'Explore aesthetic balance and inspiration between oriental',
            footerInfo2: 'and occidental, between modernity and tradition, and',
            footerInfo3: 'between memory and future.'
        },
        fnjiIndexPhoneNew: {
            aboutFnjiCon: 'FNJI was founded in 2010 and is a lifestyle aesthetics brand that',
            aboutFnjiCon2: 'integrates furniture and home furnishings."Fan" means clean and',
            aboutFnjiCon3: 'quiet, and "Ji" means furniture, which means clean and quiet',
            aboutFnjiCon4: 'furniture. At thesame time, the homonym of Fanji is "FANJI", which',
            aboutFnjiCon5: 'means ordinary furniture."Oriental modern, natural and meaningful"',
            aboutFnjiCon6: 'is the keyword of the brand, which is the concept and persistence of',
            aboutFnjiCon7: 'Fanji rooted in the soil of the East and constantly exploring aesthetic',
            aboutFnjiCon8: 'life. "NATURE BRED HOME NOURISHED" takes natural materials and',
            aboutFnjiCon9: 'simulates the state of nature. FNJI insists on using wood as the main',
            aboutFnjiCon10: 'body, integrating leather, wool, stone and other natural materials,',
            aboutFnjiCon11: 'and returning the aura taken from the mountains to daily life.',
            // aboutFnjiCon: 'Rooted in the profound oriental aesthetics, the design condenses',
            // aboutFnjiCon2: 'the expression and inheritance, and integrates the understanding',
            // aboutFnjiCon3: 'and thinking of nature.It is Fnji\'s value and mission to be loyal to the',
            // aboutFnjiCon4: 'self by conveying its distinctive style, aesthetics and lifestyle',
            // aboutFnjiCon5: 'delicately and effectively.',
            // aboutFnjiCon6: 'It is also an interpretation of the concept of “Nature bred, Home nourished”.',
            furniture: 'The concept of "Nature bred, Home nourished" of Fnji furniture',
            furniture2: 'integrates a variety of design languages such as deep solemnity,',
            furniture3: 'simplicity, modern diversity and so on. Explore aesthetic balance',
            furniture4: 'and inspiration between East and West, between modernity and',
            furniture5: 'tradition, and between memory and future. ',
            homeCon: 'Life Store selects quality household goods from around the',
            homeCon2: 'world with high standards. Quality household goods make',
            homeCon3: 'people feel happy and bring to life a sense of ceremony. More',
            homeCon4: 'importantly, they present the life aesthetic system recognized',
            homeCon5: 'and admired by Fnji.',

            fnjiAtHomeDesc: 'Fnji At Home\n' +
                'In order to deeply explore the lifestyle attitude of furniture owners and observe the relationship between furniture and people\n' +
                'Intimate connections between people, Fnji self-made program "Fnji at Home"\n' +
                'Starting from different dimensions, tell the story of furniture, design, and people\n',

            fnjiProjectDesc: 'Cooperation\n' +
                'FNJI and commercial space produce linkage, in different styles together interpret \n' +
                ' the tolerance and infinite possibilities of FNJI furniture. FNJI has been exploring the \n' +
                'resonance of design and nature between different places and objects.',

            fnjiProject: 'Commercial Project',

            fnjiathomeCon: 'In order to deeply explore the lifestyle attitude of',
            fnjiathomeCon2: 'furniture owners and observe the relationship ',
            fnjiathomeCon3: 'between furniture and people Intimate connections',
            fnjiathomeCon4: 'between people, Fnji self-made program "Fnji at',
            fnjiathomeCon5: 'Home" Starting from different dimensions, tell',
            fnjiathomeCon6: 'the story of furniture, design, and people',
            cooperationCon: 'FNJI and commercial space produce linkage, in ',
            cooperationCon2: 'different styles together interpret the tolerance',
            cooperationCon3: 'and infinite possibilities of FNJI furniture. FNJI',
            cooperationCon4: 'has been exploring the resonance of design and ',
            cooperationCon5: 'nature between different places and objects. ',
            EXHIBITION: 'EXHIBITION',
            EXHIBITION2: '',
            ARTSTAGE: 'ART STAGE',
            ARTSTAGE2: '',
            STORE: 'POP-UP STORE',
            STORE2: '',
            artCon: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-',
            artCon2: 'up Store. Fnji breaks the boundaries of traditional art and',
            artCon3: 'taps into the infinite possibilities of art. It allows the',
            artCon4: 'audience to perceive the art presented in different carriers',
            artCon5: 'and leads them into the art world of infinite imagination.',
            journalCon: 'In order to explore the living attitudes of furniture owners',
            journalCon2: 'and observe the intimate connections between furniture',
            journalCon3: 'and people and among people, Fnji makes columns "FNJI',
            journalCon4: 'at Home" and "FNJI Visit Friend" to tell the stories of',
            journalCon5: 'furniture, design and people from different dimensions.',
            projectCon: 'Fnji cooperate with commercial spaces, designers and',
            projectCon2: 'owner-principals to interpret the comprehensive and',
            projectCon3: 'infinite possibility of Fnji furniture in different styles.',
        },
        aboutFnjiNew: {
            titleOne: 'MEMORY',
            titleTwo: 'INHERITANCE',
            titleThree: 'NATURE',
            titleFour: 'TIMELESS',
            memory: 'Inspired by the perception of Chinese culture and traditional life, Fnji condenses the oriental charm and philosophy in the design and',
            memory2: 'conveys the common memory and cultural resonance of the Chinese people with the design language in line with the modern lifestyle,',
            memory3: 'hence reproducing the disappearing bygones in people\'s life in a new and lasting way, and retaining the fireworks of the memory.',
            productsImg: [
                {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: 'Replacing bamboo with wood, the shape is refined and simplified, the lines show changes in thickness,',info2: 'and the Chinese implications are revealed in the simplicity, which is the beginning of Fnji brand.'},
                {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: 'Wood and rattan are intertwined with the air flowing between to integrate the traditional Chinese elements into the modern space with moving',info2: 'lines and lifestyle. The space partition is no longer a cutting, but an independent yet connected relationship that allows people to communicate.'},
                {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: 'Inspired by the traditional Chinese bamboo cart, we use the unique Chinese design language to reproduce the most simple space',info2: 'needs in memory. It is not limited by the functions of furniture, but applicable to all spaces and scenes at home in a flexible manner.'},
                {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: 'The delicate and varied natural stone texture forms a richer touch, while the',info2: 'scattered combination of high and low highlights the unique Oriental beauty.'},
                {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: 'Decorated with the ingenious thinking of modern design on the shape of bamboo dustpan frame,',info2: 'items can be taken and displayed in four directions to outline the overlapping beauty.'},
                {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: 'The smooth and delicate wooden structure forms a portable handle, and the vegetable tanning',info2: 'seat with warm color reflects the natural mark of time.'},
                {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: 'Referring to the body of the bird cage, the cage is surrounded by thick and smooth wooden strips',info2: 'in a unique shape, forming a visual system of virtual and real communication under the soft light.'}
            ],
            inheritance: 'Inheritance of Chinese traditional crafts refers to preserving the original texture and quality of wood through the hand polishing of',
            inheritance2: 'carpenters.Each craft carries the emotional expression pursued by Fnji to present the best experience in structure, performance and',
            inheritance3: 'senses, which is not only the inheritance and protection of Chinese traditional crafts, but also the ultimate pursuit of design.',
            nature: 'Human beings are born to be close to the nature, which is in line with the essence of "originating from the wildness but settling in the house". We adhere to taking solid',
            nature2: 'wood as the main body and integrating a variety of natural materials such as leather, wool and stone, so as to introduce the aura of mountains and wildness to daily life.',
            nature3: 'We select imported materials from world-class brands to ensure safety and environmental protection and durability at the same time.',
            timeLess: '"What is the design that truly belongs to China" has always been the thinking and exploration of Fnji.',
            timeLess2: 'Behind every design there is a great love and treasure for all things in nature and humanities and art.',
            events: 'FNJI EVENTS',
            commercials: 'PREVIOUS COMMERCIALS',
            commercialsInfo: 'In addition to exploring the possibility of our own products, we also thought about the visual presentation of various',
            commercialsInfo2: 'products in last decade. This is Fnji\'s thinking on artistic beauty and the expression of brand spirit as well. Fnji hopes to',
            commercialsInfo3: 'achieve a balance between the East and the West, contemporary and tradition, memory and the future, and then explore the',
            commercialsInfo4: 'furniture belonging to the Chinese people in the future.',
            designer: 'DESIGNER'
        },
        aboutFnjiPhoneNew: {
            memory: 'Inspired by the perception of Chinese culture and traditional life, Fnji',
            memory2: 'condenses the oriental charm and philosophy in the design and',
            memory3: 'conveys the common memory and cultural resonance of the Chinese',
            memory4: 'people with the design language in line with the modern lifestyle,',
            memory5: 'hence reproducing the disappearing bygones in people\'s life in a new',
            memory6: 'and lasting way, and retaining the fireworks of the memory.',
            inheritance: 'Inheritance of Chinese traditional crafts refers to preserving the',
            inheritance2: 'original texture and quality of wood through the hand polishing of',
            inheritance3: 'carpenters.Each craft carries the emotional expression pursued by',
            inheritance4: 'Fnji to present the best experience in structure, performance and',
            inheritance5: 'senses, which is not only the inheritance and protection of Chinese',
            inheritance6: 'traditional crafts, but also the ultimate pursuit of design.',
            nature: 'Human beings are born to be close to the nature, which is in line with',
            nature2: 'the essence of "originating from the wildness but settling in the',
            nature3: 'house". We adhere to taking solid wood as the main body and',
            nature4: 'integrating a variety of natural materials such as leather, wool and',
            nature5: 'stone, so as to introduce the aura of mountains and wildness to daily',
            nature6: 'life. We select imported materials from world-class brands to ensure',
            nature7: 'safety and environmental protection and durability at the same time.',
            timeLess: '"What is the design that truly belongs to China" has always been the',
            timeLess2: 'thinking and exploration of Fnji. Behind every design there is a great',
            timeLess3: 'love and treasure for all things in nature and humanities and art.',
            commercialsInfo: 'In addition to exploring the possibility of our own products, we also',
            commercialsInfo2: 'thought about the visual presentation of various products in last',
            commercialsInfo3: 'decade. This is Fnji\'s thinking on artistic beauty and the expression',
            commercialsInfo4: 'of brand spirit as well. Fnji hopes to achieve a balance between the',
            commercialsInfo5: 'East and the West, contemporary and tradition, memory and the',
            commercialsInfo6: 'future, and then explore the furniture belonging to the Chinese',
            commercialsInfo7: 'people in the future.',
        },
        artInfoNew: {

            artTypeList: [
                {id: '100',artType: 'EXHIBITION',info: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji throughout the country and exchange and share their ' +
                        'inspirations at the scene. When there are common pursuit of aesthetics and encounters with art lovers, Fnji brings everyone who comes to the exhibition closer to art.',
                    infoPhone1: '',infoPhone2: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji throughout the country and exchange and share their inspirations ' +
                        'at the scene. When there are common pursuit of aesthetics and encounters with art lovers, Fnji brings everyone who comes to the exhibition closer to art.'},
                {id: '101',artType: 'STAGE',info: 'Fnji occasionally invites artists to create theme art stages through “playing”They are not strictly defined and they are cross-border new experiments of ' +
                        'brands and artists. They are a unique visual feast made by imagination and artworks.',
                    infoPhone2: 'Fnji occasionally invites artists to create theme art stages through “playing”They are not strictly defined and they are cross-border new experiments of brands and artists. ' +
                        'They are a unique visual feast made by imagination and artworks.'},
                {id: '102',artType: 'POP-UP',info: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique perspectives and tastes into Fnji space and inspire more sparks ' +
                        'and possibilities. ',
                    infoPhone2: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique perspectives and tastes into Fnji space and inspire more sparks and possibilities.'},
            ],
        },
        moreBtn: 'Check All',
        fnjiIndex: {
            aboutFnjiLogo: '/view-v2/web/static/img/index/fnji_about_en.png',
            indexFurnitureLogo: '/view-v2/web/static/img/index/fnji_furture_en.png',
            indexGroLogo: '/view-v2/web/static/img/index/fnji_gro_en_new.png',
            indexArtLogo: '/view-v2/web/static/img/index/fnji_art_en.png',
            indexColumnLogo: '/view-v2/web/static/img/index/fnji_column_en.png',
            indexHowBuyLogo: '/view-v2/web/static/img/index/fnji_how_buy_en.png',

            aboutFnjiCon: 'Fnji inherits traditional Chinese craftsmanship and selects quality natural materials. ',
            aboutFnjiCon2: 'With memories in life and inspiration from nature, ',
            aboutFnjiCon3: 'we create modern furniture that truly belongs to the Chinese.',
            aboutFnjiBt: 'MORE ABOUT FNJI',
            aboutBt: 'READ MORE',
            aboutAllBt: 'CHECK ALL',
            furnitureLine: '| CREST LINE | EARTH LINE | FNJI FORE |',
            crestInfo: 'Inspired by nature and childhood memories and rooted in traditional Chinese culture, the Crest Line incorporates oriental ethereal artistic elements into solemn designs. With Mantis Chair being its first product, the Crest Line has been continuously upgrading its design, structure, and craftsmanship in the last three years. It adopts solid wood with large curves and many details and fabrics of international brands to highlight the sculptural and artistic sense of modern Chinese furniture and brings to life a sense of ceremony.',
            earthInfo: 'The Earth Line is the earliest line of Fnji. With its simple style, it focuses on the home design that is needed by ordinary people in real life. While keeping traditional Chinese design, the Earth Line turns trees in nature into furniture integrated with home. These pieces of furniture accompany us through all seasons and gradually become our family members.',
            ffInfo: 'FF refers to Fnji Fore and represents a step forward of Fnji. It is a new experimental product line. Instead of inheriting traditional craftsmanship, the FF Line is simpler in its design and gives the furniture more possibilities with the combination of various materials and craftsmanship. It has both modern simplicity and a sense of warmth.',
            groceryInfo: 'Fnji Home Museum continues the concept of “born in nature and settled at home” and selects quality household goods from around the world with high standards. ',
            groceryInfo2: 'Quality household goods make people feel happy and bring to life a sense of ceremony.',
            groceryInfo3: 'They perfectly match with furniture and are also a good choice for holiday gifts. More importantly,',
            groceryInfo4: 'they present the life aesthetic system recognized and admired by Fnji.',
            galleryInfo: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-up Store. Fnji breaks the boundaries of traditional art',
            galleryInfo2: 'and taps into the infinite possibilities of art. ',
            galleryInfo3: 'It allows the audience to perceive the art presented in different carriers and leads them into the art world of infinite imagination.',
            columnInfo: 'In order to explore the living attitudes of furniture owners and observe the intimate connections between',
            columnInfo2: 'furniture and people and among people, Fnji makes columns "FNJI at Home" and "FNJI Visit Friend" to tell the',
            columnInfo3: 'stories of furniture, design and people from different dimensions.',
            phyStore: 'STORE LOCATOR',
            phyStores: '| BEIJING | SHANGHAI | Guangzhou | SHENZHEN | CHENGDU | HANGZHOU | SUZHOU | NANJING |',
            lineStore: 'ONLINE STORES',
            lineStores: '| TMALL | JD | WX |',
            indexDown: '/view-v2/web/static/img/index/index2020_new_en.png',
            indexDown2: 'BETWEEN MODERNITY AND TRADITION, AND BETWEEN MEMORY AND FUTURE. '
        },
        catalog: {
            name: 'Catalog',
            btn: 'Download'
        },
        aboutFnji: {
            aboutFnji1Title: 'REMAIN TRUE TO OUR ORIGINAL ASPIRATION WITH EFFORTS OVER THE PAST DECADE',
            aboutFnji1: 'Founded in 2010 by designer Gao Guqi, Fnji (梵几) is a pioneer representative of Chinese original',
            aboutFnji12: 'furniture. “梵” refers to serenity and “几” refers to furniture',
            aboutFnji13: 'so “梵几” refers to furniture with a sense of serenity',
            aboutFnji14: 'Fnji has been thinking about and exploring “what is the design that really belongs to China".',
            aboutFnji2Title: 'INHERIT TRADITIONAL CHINESE CRAFTS',
            aboutFnji2: 'Fnji preserves the original texture and feel of the wood through carpenters’ grinding.',
            aboutFnji22: 'For the treatment of each corner and line, the carpenter will need more than ten years’ experience.',
            aboutFnji23: 'This is  Fnji’s inheritance and protection of traditional Chinese crafts and pursuit of design.',
            aboutFnji3Title: 'SELECT QUALITY NATURAL MATERIALS',
            aboutFnji3: 'Fnji takes solid wood as the main material and uses many other natural materials like leather, wool, and stone. We select imported materials of world-class brands so that our products are both safe and environmentally friendly and durable. This is consistent with our concept of “born in nature and settled at home” and brings people back to nature. ',
            aboutFnji4Title: 'GET INSPIRATION FROM MEMORY',
            aboutFnji4: 'Design should not be simply loaded with lines and elements. Fnji\'s design is inspired by the perception of Chinese culture and traditional life and embodies oriental flavor and philosophy. Behind every design is our great love and cherishment of nature and humanities.',
            aboutFnji5Title: '十年 寻河',
            aboutFnji5: '十年。寻河。',
            aboutFnji51: '“不知道从什么时候开始，我经常做一个类似的梦。梦里的自己在寻找一条河，那条河清澈见底，应该就在不远处。',
            aboutFnji52: '但这也许只是我梦中的景象，',
            aboutFnji53: '那条河，我仍未找到。”',
            aboutFnji54: '梵几从创立到不断变得完整，也如同一场寻河之旅。'
        },
        cooperateItem: [
            { title: 'BULK PIRCHASE', desc: '', type: 1, class: 'project'},
            { title: 'DESIGN STUDIO COLLABORATION', desc: '', type: 2, class: 'desgin'},
            { title: 'HOME FURNISHING BRAND COOPERATION', desc: '', type: 3, class: 'grocery'},
            { title: 'MARKETING & MEDIA COOPERATION', desc: '', type: 4, class: 'marketing'},
            { title: 'ARTWORK COLLABORATION', desc: '', type: 5, class: 'gallery'}
        ],
        cooperateFnji: {
            topTitle: 'Contact Us',
            topCon: 'FNJI has opened to the outside world about multi-directional business cooperation.',
            topCon2: 'If you are interested in cooperation, please click the corresponding entry to fill',
            topCon3: 'in the information. We will reply to you within 5 working days if necessary.',
            companyName: 'Company Name',
            projectName: 'Project Name',
            city: 'City',
            budget: 'Budget',
            time: 'Time requirement for delivery',
            contact: 'Contact',
            position: 'Position',
            phoneNumber: 'Phone Number',
            phone: 'Phone Number',
            companyIntro: 'Company Introduction',
            project: 'Collaboration Project',
            artistBrandstudio: 'Artist/Brand/studio',
            summary: 'Summary',
            email: 'Email',
            importantEmail: 'Email(very important）',
            attachFile: 'Attach File',
            fileTips: 'The attachment must not exceed 15M; you may upload JPG or PDF files.',
            note: 'Note',
            submit: 'Submit',
            successfully: 'Submitted successfully'
        },
        fnjiAtHome: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji furniture in different people\'s homes, it shares different uses of furniture and conveys the living attitude of furniture owners.',
        fnjiVisitFriend: 'In 2009, one year before the founding of Fnji, Guqi (founder and chief designer of Fnji) came to Beijing. At that time, he met with friends either in a coffee shop or a shopping mall. When he was a child, however, parents and friends visited each other at home. With such an unforgettable memory, he launched a “visiting friends” activity among his friends.',
        addCart: 'ADD TO CART',
        buy: 'SHOP NOW',

        buyChannel:{
            online: 'Online Store',
            project: 'Commercial Project',
            shop: 'Showrooms',
        },

        clickShow: {
            partOne: 'Check',
            partTwo: 'delivery information',
            partThree: 'or',
            partFour: 'membership'
        },
        usingClick: {
            partOne: 'Click to buy',
            partTwo: 'Furniture Maintenance Set'
        },
        artInfo: {
            artExhibtion1: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji',
            artExhibtion2: 'throughout the country and exchange and share their inspirations at the scene.',
            artExhibtion3: 'When there are common pursuit of aesthetics and encounters with art lovers,',
            artExhibtion4: 'Fnji brings everyone who comes to the exhibition closer to art.',
            artExhibtionBtn: 'Check All',
            artStage1: 'Fnji occasionally invites artists to create theme art stages through',
            artStage2: '“playing”. They are not strictly defined and they are cross-border new',
            artStage3: 'experiments of brands and artists. They are a unique visual feast made',
            artStage4: 'by imagination and artworks.',
            artStageBtn: 'Check All',
            artStore1: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique',
            artStore2: 'perspectives and tastes into Fnji space and inspire more sparks and possibilities.',
        },
        homeInfo: {
            homeTitle: 'FNJI AT HOME',
            homeAtHome1: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji furniture in',
            homeAtHome2: 'different people\'s homes, it shares different uses of furniture and conveys the',
            homeAtHome3: 'living attitude of furniture owners.',
            homeBtn: 'More',
            homeVisitTitle: 'VISITING FRIENDS',
            homeVisit1: 'In 2009, one year before the founding of Fnji, Guqi (founder and chief',
            homeVisit2: 'designer of Fnji) came to Beijing. At that time, he met with friends either in a',
            homeVisit3: 'coffee shop or a shopping mall. When he was a child, however, parents and',
            homeVisit4: 'friends visited each other at home. With such an unforgettable memory, he',
            homeVisit5: 'launched a “visiting friends” activity among his friends.'
        },
        homeInfoPhone: {
            homeAtHome1: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji',
            homeAtHome2: 'furniture in different people\'s homes, it shares different uses of',
            homeAtHome3: 'furniture and conveys the living attitude of furniture owners.',
            homeVisit1: 'In 2009, one year before the founding of Fnji, Guqi (founder and',
            homeVisit2: 'chief designer of Fnji) came to Beijing. At that time, he met with',
            homeVisit3: 'friends either in a coffee shop or a shopping mall. When he was',
            homeVisit4: 'a child, however, parents and friends visited each other at home.',
            homeVisit5: 'With such an unforgettable memory, he launched a “visiting',
            homeVisit6: 'friends” activity among his friends.'
        },
        typeList: [
            {name: 'All',tab: '',link: '/furniture?tab=all'},
            {name: 'Chair',tab: '#chair',link: '/furniture?tab=all#chair'},
            {name: 'Table',tab: '#desk',link: '/furniture?tab=all#desk'},
            {name: 'Bed',tab: '#bed',link: '/furniture?tab=all#bed'},
            {name: 'Teapoy',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
            {name: 'Cabinet',tab: '#cab',link: '/furniture?tab=all#cab'},
            {name: 'Sofa',tab: '#sofa',link: '/furniture?tab=all#sofa'},
            {name: 'Plank',tab: '#ymb',link: '/furniture?tab=all#ymb'},
            {name: 'Other',tab: '#other',link: '/furniture?tab=all#other'}
        ],
        newTypeList: [
            {name: 'New',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
            {name: 'Crest Line',tab: 'base',link: '/furniture-l2?bom=base'},
            {name: 'Earth Line',tab: 'high',link: '/furniture-l2?bom=high'},
            {name: 'Fnji Fore',tab: 'ff',link: '/furniture-l2?bom=ff'},
            // {name: '回顾',tab: '',link: '/furniture-l2?bom=ff'},
        ],
        groTypeList: [
            {theName: 'All',name: '全部',bom: '',link: '/grocery?tab=all'},
            {theName: 'Lighting',name: '灯具',bom: 'C01-11',link: '/grocery-l2?bom=C01-11'},
            {theName: 'Textiles',name: '家纺',bom: 'C01-12',link: '/grocery-l2?bom=C01-12'},
            {theName: 'Dinning&Kitchen',name: '餐厨用品',bom: 'C01-13',link: '/grocery-l2?bom=C01-13'},
            {theName: 'Storage',name: '收纳杂物',bom: 'C01-14',link: '/grocery-l2?bom=C01-14'},
            {theName: 'Fragrance',name: '香氛洗护',bom: 'C01-15',link: '/grocery-l2?bom=C01-15'},
            {theName: 'Accessories',name: '装饰',bom: 'C01-16',link: '/grocery-l2?bom=C01-16'},
            {theName: 'Electronics',name: '家居电器',bom: 'C01-17',link: '/grocery-l2?bom=C01-17'},
            {theName: 'Outdoor',name: '户外园艺',bom: 'C01-18',link: '/grocery-l2?bom=C01-18'},
            {theName: 'Lifestyle',name: '文创',bom: 'C01-19',link: '/grocery-l2?bom=C01-19'}
        ]
    };
    return  en;
});



//////////////////
// WEBPACK FOOTER
// ../i18n/config/en.js
// module id = 23
// module chunks = 0 1 2 3 4 5 6